// extracted by mini-css-extract-plugin
export default {"description":"style_description__Rvky-","fade-in":"style_fade-in__hnJ4Z","top":"style_top__MCdxY","image":"style_image__u967C"};